/* RIPOST · PDP c2v3 (31/10/2026, pt290u) : pilote les selects natifs (cachés) de <variant-picker>
   depuis les vignettes radar et les 2 cases à cocher. Le thème garde la main : événement change
   sur le select -> variant-picker.js (fetch, prix, ?variant=, dispo, ATC, paiement accéléré).
   Délégation sur document : survit au remplacement innerHTML du variant-picker. Voir assets/CUSTOM.txt. */
(function(){
  if(window.__rpPdp)return;window.__rpPdp=1;
  var refocus=null;
  function fire(sel,val){
    if(!sel||sel.value===val)return false;
    sel.value=val;
    sel.dispatchEvent(new Event('change',{bubbles:true}));
    return true;
  }
  function live(row,txt,preview){
    var p=row.closest('[data-rp-mount]'),l=p&&p.querySelector('[data-rp-live]');if(!l)return;
    l.textContent=txt==null?l.getAttribute('data-rp-sel'):txt;
    l.classList.toggle('is-preview',!!preview);
  }
  function pick(btn,focus){
    var m=btn.closest('[data-rp-mount]'),sel=m&&m.querySelector('select[data-rp-sel=mount]');if(!sel)return;
    var val=btn.getAttribute('data-rp-val');
    m.querySelectorAll('.rp-pm__t').forEach(function(b){var on=b===btn;b.setAttribute('aria-checked',on?'true':'false');b.tabIndex=on?0:-1});
    var l=m.querySelector('[data-rp-live]');if(l){l.setAttribute('data-rp-sel',val);l.textContent=val;l.classList.remove('is-preview')}
    var row=btn.parentNode;refocus={k:'m',v:val,f:!!focus,s:row.scrollLeft};
    fire(sel,val);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.rp-pm__t');if(!b)return;
    e.preventDefault();pick(b,document.activeElement===b||e.detail===0);
  });
  document.addEventListener('keydown',function(e){
    var b=e.target.closest&&e.target.closest('.rp-pm__t');if(!b)return;
    var all=[].slice.call(b.parentNode.querySelectorAll('.rp-pm__t')),i=all.indexOf(b),n=i;
    if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%all.length;
    else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i-1+all.length)%all.length;
    else if(e.key==='Home')n=0;else if(e.key==='End')n=all.length-1;
    else if(e.key===' '||e.key==='Enter'){e.preventDefault();pick(b,true);return}
    else return;
    e.preventDefault();all[n].focus();pick(all[n],true);
  });
  document.addEventListener('mouseover',function(e){var b=e.target.closest&&e.target.closest('.rp-pm__t');if(b)live(b,b.getAttribute('data-rp-val'),true)});
  document.addEventListener('mouseout',function(e){var b=e.target.closest&&e.target.closest('.rp-pm__t');if(b&&!(e.relatedTarget&&b.contains(e.relatedTarget)))live(b,null,false)});
  document.addEventListener('focusin',function(e){var b=e.target.closest&&e.target.closest('.rp-pm__t');if(b&&b.matches(':focus-visible'))live(b,b.getAttribute('data-rp-val'),true)});
  document.addEventListener('focusout',function(e){var b=e.target.closest&&e.target.closest('.rp-pm__t');if(b)live(b,null,false)});
  /* Cases à cocher : intercepté en capture pour que variant-picker.js ne traite pas la case elle-même. */
  document.addEventListener('change',function(e){
    var c=e.target;if(!c.matches||!c.matches('[data-rp-addon]'))return;
    e.stopPropagation();
    var g=c.closest('[data-rp-addons]'),sel=g&&g.querySelector('select[data-rp-sel=addons]');if(!sel)return;
    var cam=g.querySelector('[data-rp-addon=cam]'),pl=g.querySelector('[data-rp-addon=plate]');
    var role=cam.checked&&pl.checked?'both':cam.checked?'cam':pl.checked?'plate':'none';
    var o=sel.querySelector('option[data-rp-role='+role+']');if(!o)return;
    refocus={k:'a',v:c.getAttribute('data-rp-addon'),f:document.activeElement===c};
    fire(sel,o.value);
  },true);
  document.addEventListener('variant:updated',function(){
    if(!refocus)return;var r=refocus;refocus=null;
    requestAnimationFrame(function(){
      var el=null;
      if(r.s!=null)document.querySelectorAll('[data-rp-row]').forEach(function(w){w.scrollLeft=r.s});
      if(!r.f)return;
      if(r.k==='m')document.querySelectorAll('[data-rp-mount] .rp-pm__t[aria-checked=true]').forEach(function(b){if(b.getAttribute('data-rp-val')===r.v)el=b});
      else el=document.querySelector('[data-rp-addon='+r.v+']');
      if(el&&document.activeElement!==el)el.focus({preventScroll:true});
    });
  });
})();
